import styled, { css } from 'styled-components';
import { CustomCheckbox } from '../Checkbox/style';
import { StyledBadge } from '../Badge/style';

export const SelectWrapper = styled.div`
  position: relative;
  width: fit-content;

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
  }
`;

export const SelectContainer = styled.div`
  display: flex;
  min-width: 132px;
  max-width: 240px;
  height: 40px;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.link};
  background: ${(props) => props.theme.colors.white};
  cursor: pointer;
  justify-content: space-between;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.focusRing};
    outline-offset: -2px;
  }

  .title {
    color: ${(props) => props.theme.colors.link};
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
    max-width: 100%;
  }

  ${({ size }) =>
    size === 's' &&
    css`
      height: 27px;
      padding: 5px 10px;
      .title {
        font-size: 12px;
        line-height: 16px;
      }
    `}
`;

export const Dropdown = styled.div.withConfig({
  shouldForwardProp: (prop) => !['position'].includes(prop),
})`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 322px;
  padding: 16px;
  border-radius: 4px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  z-index: 99;

  ${({ position }) =>
    position?.includes('top') &&
    css`
      top: unset;
      bottom: calc(100% + 6px);
    `}

  ${({ position }) =>
    position?.includes('right') &&
    css`
      left: unset;
      right: 0;
    `}

  .years-wrapper {
    padding-bottom: 16px;
    border-bottom: 1px solid ${(props) => props.theme.colors.border};

    ${StyledBadge} {
      margin: 0 auto;
    }

    .slick-arrow.slick-prev,
    .slick-arrow.slick-next {
      left: -12px;
      &::before {
        content: '';
        display: none;
      }
    }
    .slick-arrow.slick-next {
      transform: rotate(180deg);
      right: -12px;
      left: unset;
      top: 3px;
    }
  }

  .month {
    padding: 12px;
    border-bottom: 1px solid ${(props) => props.theme.colors.border};

    ${CustomCheckbox} {
      bottom: 0;
    }

    label {
      text-transform: capitalize;
      font-size: 18px;
      margin-left: 12px;
      color: ${(props) => props.theme.colors.textPrimary};
    }

    &.active {
      background-color: ${(props) => props.theme.colors.bgBox};
    }
  }
`;
